module.exports = __webpack_public_path__ + "img/logistics.21685952.png";